<template>
    <span>
      <vx-tooltip text="Archivar proyecto">
        <vs-button
            icon="inventory_2"
            color="danger"
            @click="archiveModal()" v-if="project.status <= 6 && project.resolution_date === null">
        </vs-button>
      </vx-tooltip>

        <vs-popup title="Resolución del proyecto" :active.sync="showDialog" style="z-index: 10 !important;">
            <div class="row">
                <!-- ¿Quién va a rechazar? -->
                <div class="col-md-12 mb-4">
                    <h6 class="mb-4 bold">¿Quién tomó la decisión de archivar el proyecto?</h6>
                    <ul class="centerx" @click="resetForm()">
                        <li>
                            <vs-radio v-model.number="actor" color="warning" vs-value="1">
                                RedGirasol
                            </vs-radio>
                        </li>
                        <li>
                            <vs-radio v-model.number="actor" color="warning" vs-value="2">
                                Instalador
                            </vs-radio>
                        </li>
                        <li>
                            <vs-radio v-model.number="actor" color="warning" vs-value="3">
                                Solicitante
                            </vs-radio>
                        </li>
                    </ul>
                    <vs-divider></vs-divider>
                </div>
                <!-- ¿Por qué? -->
                <div class="col-md-12 mb-4">
                    <h6 class="bold mb-4">Categoría</h6>
                    <div class="col-md-12 mb-4">
                      <vs-select class="w-full mb-5" 
                        v-model.lazy="categorySelected"
                        name="getCollection"
                        v-validate="'required'"
                        placeholder="Seleccione una opción" >
                          <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in getCollection"
                          class="w-full"
                          />
                      </vs-select>
                    </div>
                    <h6 class="bold mb-4">Razón</h6>
                    <div class="col-md-12 mb-4">
                      <vs-select class="w-full mb-5" 
                          v-validate="'required'" name="resolutions"
                          label="Seleccione una opción"
                          :disabled="categorySelected === null"
                          v-model.number="resolutionSelected">
                        <vs-select-item
                          :key="index" 
                          :value="item.value" 
                          :text="item.text" 
                          v-for="(item,index) in collections.resolutions" 
                          class="w-full" />
                      </vs-select>
                    </div>
                    <h6 v-if="isOther" class="bold mb-4">Otra razón</h6>
                    <div v-if="isOther" class="col-md-12">
                        <textarea maxlength="255" name="name" class="form-control" v-model="otherReasonText"></textarea>
                    </div>
                </div>
              <!-- Botones -->
                <div class="col-md-12 mb-4">
                    <div class="ml-4 flex flex-wrap items-center justify-end align-right">
                        <vs-button :disabled="categorySelected === null && resolutionSelected === null"
                                   @click="requestArchive()" color="warning"
                                   class="ml-auto mt-2 mr-2">Archivar proyecto</vs-button>
                        <vs-button @click="closePrompt()" color="danger" class="ml-2 mt-2">Cancelar</vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>
    </span>
</template>

<script>
import {mapActions} from 'vuex'

const rgCategory = [
  {value: "2", text: "Perfil de solicitante y proyecto"}
  , {value: "14", text: "No definido"}
  , {value: "22", text: "Rechazo por modelo de riesgo"}
  , {value: "23", text: "Historial crediticio"}
  , {value: "24", text: "Alto nivel de endeudamiento:"}
  , {value: "25", text: "Resultado “No recomendable” en visita domiciliaria:"}
  , {value: "26", text: "Riesgo en comportamiento de pago de servicios CFE."}
  , {value: "27", text: "Análisis de Solvencia y Veracidad de la Información Financiera"}
  , {value: "28", text: "Falta de documentación de ingresos"}
  , {value: "29", text: "Inestabilidad laboral o económica:"}
  , {value: "30", text: "Documentación incompleta o contradictoria:"}
  , {value: "31", text: "Edad fuera del rango permitido"}
  , {value: "32", text: "Ubicación fuera de zona permitida"}
  , {value: "33", text: "Relación con personas políticamente expuestas (PEP)"}
  , {value: "34", text: "Incumplimiento de políticas del producto o segmento"}
  , {value: "35", text: "Antecedentes judiciales o legales"}
];

const applicantCategory = [
  {value: "4", text: "Solicitante optó por otro crédito"}
  , {value: "5", text: "Solicitante lo pagó de contado"}
  , {value: "6", text: "Solicitante canceló el proyecto"}
  , {value: "7", text: "Solicitante no cuenta con requisito"}
  , {value: "8", text: "No le gustó el financiamiento de RedGirasol"}
  , {value: "9", text: "Solicitante no cuenta con obligado solicitado"}
  , {value: "10", text: "Solicitante no cuenta con enganche solicitado"}
  , {value: "11", text: "Ya no se tiene contacto con solicitante"}
];

const supplierCategory = [
  {value: "12", text: "No le gustó el financiamiento de RedGirasol"}
  , {value: "13", text: "Faltan condiciones de instalador"}
  , {value: "21", text: "Solicitud creada por el instalador"}
];

const otherResolutiondIds = [4, 6, 14, 20, 24, 29, 39, 41];


export default {
  name: "ProjectArchiveButton",
  props: ['project'],
  data: () => ({
    showDialog: false,
    actor: 1,
    rgCategory: rgCategory,
    applicantCategory: applicantCategory,
    supplierCategory: supplierCategory,
    categorySelected: null,
    resolutionSelected: null,
    collections: {
      resolutions: []
    },
    otherResolutiondIds: otherResolutiondIds,
    otherReasonText: ""
  }),
  methods: {
    ...mapActions("projects", ['archiveProject']),
    archiveModal() {
      this.closePrompt();
      this.showDialog = true;
    },
    async requestArchive() {
      if (this.resolutionSelected !== null) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Archivar solicitud',
          text: `¿Estás seguro que deseas archivar la solicitud ${this.project.id}?.`,
          acceptText: "Archivar solicitud",
          cancelText: 'Cancelar',
          accept: this.archive
        });
      }
    },
    async archive() {
      this.showLoading(true);
      try {
        await this.archiveProject({
          id: this.project.id,
          resolution_id: this.resolutionSelected,
          resolution_other: this.otherReasonText
        })
        this.showDialog = false;
        this.$emit('on-save');
        this.saveSuccessNotif();
      } catch (e) {
        swal("Ups!", "Hubo un error al archivar el proyecto!", "error")
        console.error(e)
      } finally {
        this.showLoading(false);
      }
    },
    async getCollections() {
      try {
        const res = await axios.get(`/api/v1/forms/getResolutionByCategory/${this.categorySelected}`);
        let data = res.data;
        this.collections.resolutions = [];
        this.resolutionSelected = null;

        data.forEach(element => {
          let obj = {
            value: element.id,
            text: element.description
          }
          this.collections.resolutions.push(obj);
        });

      } catch (e) {
        this.warn(e);
      }
    },

    resetForm() {
      this.categorySelected = null;
      this.resolutionSelected = null;
    },
    closePrompt() {
      this.resetForm();
      this.collections.resolutions = [];
      this.resolutionSelected = null;
      this.actor = 1;
      this.showDialog = false;
    }
  },
  computed: {
    getCollection() {
      if (this.actor === 1) {
        return this.rgCategory;
      } else if (this.actor === 2) {
        return this.supplierCategory;
      } else if (this.actor === 3) {
        return this.applicantCategory;
      }

    },
    isOther() {
      return this.otherResolutiondIds.some(x => x === this.resolutionSelected);
    }
  },
  watch: {
    categorySelected: function (event) {
      this.getCollections();
    }
  }
}
</script>

<style scoped>

</style>
